module.exports = __webpack_public_path__ + "img/discoverCard.851c6ce4.png";